import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { prepareInitialDomain } from "@/utils/sbDomain";
import { enforceLexDomain } from "@/utils/lexDomain";
import { initPostHog } from "@/lib/analytics";

// PostHog früh initialisieren — sendet dank opt_out_capturing_by_default
// KEINE Events, bis der Nutzer im Cookie-Banner zustimmt (DSGVO).
initPostHog();

// Synchrone Domain-Trennung VOR dem ersten Render, damit auf der SB-Subdomain
// nicht kurz die Freelancer-Root-Route aufblitzt (Flacker-Bug). Bei einem
// harten Cross-Origin-Redirect rendern wir React gar nicht erst.
// lex zuerst: lex-Pfade auf der Hauptdomain → lex.ivoliq.io (strikte Trennung).
const lexRedirected = enforceLexDomain(window.location.pathname, window.location.search);
if (!lexRedirected && !prepareInitialDomain()) {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
